<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Add navigation tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'company' }"
            @click="activeTab = 'company'">
            Şirket Ayarları
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'searchingMachines' }"
            @click="activeTab = 'searchingMachines'">
            Aradığı Makinalar
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'ownMachines' }"
            @click="activeTab = 'ownMachines'">
            Sahip Olduğu Makinalar
          </a>
        </li>

      </ul>

      <!-- Company Edit Form -->
      <div class="row" v-show="activeTab === 'company'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Şirket Düzenle</h4>
              <p class="card-category">Ticaret yaptığınız şirketi düzenleyin.</p>


              <form class="m-5">
                <div class="row">
                  <div class="col-md-8">
                    <base-input type="text" label="Şirket Adı (Başlık)" placeholder="Şirket Adı" v-model="company.title">
                    </base-input>
                  </div>


                  <div class="col-md-4">
                    <base-input type="text" label="Vergi Numarası" placeholder="Vergi Numarası"
                      v-model="company.identityNumber">
                    </base-input>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-3">
                    <base-input type="text" label="Ülke" placeholder="Ülke" v-model="company.country">
                    </base-input>
                  </div>
                  <div class="col-md-3">
                    <base-input type="text" label="Şehir" placeholder="Şehir" v-model="company.city">
                    </base-input>
                  </div>
                  <div class="col-md-6">
                    <base-input type="text" label="Adres" placeholder="Adres" v-model="company.address">
                    </base-input>
                  </div>
                </div>





                <div class="row">
                  <div class="col-md-12">
                    <label>Şirket Kontakları</label>
                    <div v-for="(contact, index) in company.contactList" :key="index" class="d-flex mb-2">
                      <input type="text" class="form-control mr-2" v-model="contact.name" placeholder="İsim">
                      <input type="text" class="form-control mr-2" v-model="contact.email" placeholder="Email">
                      <input type="text" class="form-control mr-2" v-model="contact.phone" placeholder="Telefon">
                      <button class="btn btn-danger btn-sm btn-fill" @click="removeContact(index)">Sil</button>
                    </div>
                    <div class="mt-2">

                      <button class="btn btn-sm btn-primary" @click="addContact()">Yeni Kontak Ekle</button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label>Şirket Web Adresleri</label>
                    <div v-for="(domain, index) in company.companyDomainList" :key="index" class="d-flex mb-2">
                      <input type="text" class="form-control mr-2" v-model="company.companyDomainList[index]"
                        placeholder="www.orneksirket.com">
                      <button class="btn btn-danger btn-sm btn-fill" @click="removeDomain(index)">Sil</button>
                    </div>
                    <div class="mt-2">

                      <button class="btn btn-sm btn-primary" @click="addDomain()">Yeni Domain Ekle</button>
                    </div>
                  </div>
                </div>


                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="company.isActive"
                      :checked="company.isActive" @click="company.isActive = !company.isActive">
                    </base-checkbox>
                  </div>
                </div>






                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="updateCompany()">
                    Güncelle
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </template>
          </card>

        </div>
      </div>

      <!-- Searching Machines Edit Form -->
      <div class="row" v-show="activeTab === 'searchingMachines'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Şirketin Aradığı Makinalar</h4>
              <p class="card-category">Şirketin aradığı makinaları düzenleyin, aradığı makinaları seçin.</p>
              
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <label>Aradığı Makinalar</label>
                    
                    <!-- Machine Cards -->
                    <div v-for="(machine, index) in searchingMachines" :key="index" class="card mb-4">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <h5 class="card-title">Makina #{{index + 1}} <span class="text-muted" v-if="machine.createdAt"> - Kayıt tarihi: {{new Date(machine.createdAt).toLocaleDateString('tr-TR') }}</span> <span class="text-muted" v-if="machine.updatedAt"> - Güncelleme tarihi: {{new Date(machine.updatedAt).toLocaleDateString('tr-TR') }}</span></h5>
                          <button class="btn btn-danger btn-sm btn-fill" @click="removeSearchMachine(index)">
                            <i class="fa fa-trash"></i> Sil
                          </button>
                        </div>

                        <!-- Basic Info -->
                        <div class="row mb-3">
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Makina Adı</label>
                              <input type="text" class="form-control" v-model="machine.title" placeholder="Makina Adı">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Marka</label>
                              <input type="text" class="form-control" v-model="machine.brand" placeholder="Markası">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Model</label>
                              <input type="text" class="form-control" v-model="machine.modelName" placeholder="Model">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Model Yılı</label>
                              <input type="number" class="form-control" v-model="machine.modelYear" placeholder="Model Yılı">
                            </div>
                          </div>
                        </div>

                        <!-- Attributes -->
                        <div class="row mb-3">
                          <div class="col-12">
                            <label>Özellikler</label>
                            <div class="attributes-container">
                              <div v-for="(attr, attrIndex) in machine.attributes" :key="attrIndex" 
                                   class="d-flex align-items-center mb-2">
                                <div class="d-flex flex-grow-1">
                                  <input type="text" 
                                         class="form-control form-control-sm mr-2" 
                                         v-model="attr.key" 
                                         placeholder="Özellik Adı">
                                  <input type="text" 
                                         class="form-control form-control-sm" 
                                         v-model="attr.value" 
                                         placeholder="Değer">
                                </div>
                                <button class="btn btn-danger btn-sm ml-2" 
                                        @click="removeAttributeSearchingMacnines(index, attrIndex)">
                                  <i class="fa fa-times"></i>
                                </button>
                              </div>
                              <button class="btn btn-primary btn-sm mt-2" 
                                      @click="addAttributeSearchingMachines(index)">
                                <i class="fa fa-plus"></i> Özellik Ekle
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Note -->
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <label>Not</label>
                              <textarea class="form-control" 
                                      v-model="machine.note" 
                                      placeholder="Makina hakkında ek notlar..."
                                      rows="3"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mb-4">
                      <button class="btn btn-primary" @click="addSearchMachine()">
                        <i class="fa fa-plus"></i> Yeni Makina Ekle
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill mb-3" @click="updateSearchMachines()">
                    <i class="fa fa-save"></i> Aradığı Makinaları Güncelle
                  </button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>


      <!-- Own Machines Portfolio Edit Form -->
      <div class="row" v-show="activeTab === 'ownMachines'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Şirketin Sahip Olduğu Makinalar</h4>
              <p class="card-category">Şirketin sahip olduğu makinaları ekleyin. Daha sonra kolay bir şekilde arayabilirsiniz.</p>
              
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <label>Elindeki Makina Portfoyu</label>
                    
                    <!-- Machine Cards -->
                    <div v-for="(machine, index) in ownMachines" :key="index" class="card mb-4">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <h5 class="card-title">Makina #{{index + 1}} <span class="text-muted" v-if="machine.createdAt"> - Kayıt tarihi: {{new Date(machine.createdAt).toLocaleDateString('tr-TR') }}</span> <span class="text-muted" v-if="machine.updatedAt"> - Güncelleme tarihi: {{new Date(machine.updatedAt).toLocaleDateString('tr-TR') }}</span></h5>
                          <button class="btn btn-danger btn-sm btn-fill" @click="removeOwnMachine(index)">
                            <i class="fa fa-trash"></i> Sil
                          </button>
                        </div>

                        <!-- Basic Info -->
                        <div class="row mb-3">
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Makina Adı</label>
                              <input type="text" class="form-control" v-model="machine.title" placeholder="Makina Adı">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Marka</label>
                              <input type="text" class="form-control" v-model="machine.brand" placeholder="Markası">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Model</label>
                              <input type="text" class="form-control" v-model="machine.modelName" placeholder="Model">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Model Yılı</label>
                              <input type="number" class="form-control" v-model="machine.modelYear" placeholder="Model Yılı">
                            </div>
                          </div>
                        </div>

                        <!-- Attributes -->
                        <div class="row mb-3">
                          <div class="col-12">
                            <label>Özellikler</label>
                            <div class="attributes-container">
                              <div v-for="(attr, attrIndex) in machine.attributes" :key="attrIndex" 
                                   class="d-flex align-items-center mb-2">
                                <div class="d-flex flex-grow-1">
                                  <input type="text" 
                                         class="form-control form-control-sm mr-2" 
                                         v-model="attr.key" 
                                         placeholder="Özellik Adı">
                                  <input type="text" 
                                         class="form-control form-control-sm" 
                                         v-model="attr.value" 
                                         placeholder="Değer">
                                </div>
                                <button class="btn btn-danger btn-sm ml-2" 
                                        @click="removeAttributeOwnMachines(index, attrIndex)">
                                  <i class="fa fa-times"></i>
                                </button>
                              </div>
                              <button class="btn btn-primary btn-sm mt-2" 
                                      @click="addAttributeOwnMachines(index)">
                                <i class="fa fa-plus"></i> Özellik Ekle
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Note -->
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <label>Not</label>
                              <textarea class="form-control" 
                                      v-model="machine.note" 
                                      placeholder="Makina hakkında ek notlar..."
                                      rows="3"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mb-4">
                      <button class="btn btn-primary" @click="addOwnMachine()">
                        <i class="fa fa-plus"></i> Yeni Makina Ekle
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill mb-3" @click="updateOwnMachines()">
                    <i class="fa fa-save"></i> Sahip Olduğu Makinaları Güncelle
                  </button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      company: {
        title: "",
        country: "",
        city: "",
        address: "",
        identityNumber: "",
        companyDomainList: [],
        contactList: [],
        isActive: true
      },
      currencies: [{
        _id: "EUR",
        name: "Euro"
      }, {
        _id: "USD",
        name: "Dolar"
      }, {
        _id: "TRY",
        name: "Türk Lirası"
      }
      ],
      statusMap: [
        {
          _id: "active",
          name: "Listede"
        },
        {
          _id: "inactive",
          name: "Pasif"
        },
        {
          _id: "sold",
          name: "Satıldı"
        },
        {
          _id: "pending",
          name: "Beklemede"
        },
        {
          _id: "rented",
          name: "Kiralandı"
        },
        {
          _id: "maintenance",
          name: "Tamirde"
        },
        {
          _id: "other",
          name: "Diğer"
        }
      ],
      activeTab: 'company',
      searchingMachines: [],
      ownMachines: []
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getCompany();
  },
  methods: {
    updateCompany() {
      CollectionService.updateCollectionItem('company', this.company._id, this.company).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Şirket Güncellendi")
          this.$router.push(`/admin/companies`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getCompany() {
      console.log(this.id)
      CollectionService.getCollectionItemWithId('company', this.id).then((res) => {
        this.company = res.company;
        this.searchingMachines = res.searchingMachines;
        this.ownMachines = res.companyOwnMachines;
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    addContact() {
      this.company.contactList.push({
        name: "",
        email: "",
        phone: ""
      })
    },
    removeContact(index) {
      this.company.contactList.splice(index, 1);
    },
    addDomain() {
      this.company.companyDomainList.push("")
    },
    removeDomain(index) {
      this.company.companyDomainList.splice(index, 1);
    },
    addSearchMachine() {
      this.searchingMachines.push({
        title: "",
        brand: "",
        modelName: "",
        modelYear: "",
        attributes: [],
        note: ""
      })
    },
    addOwnMachine() {
      this.ownMachines.push({
        title: "",
        brand: "",
        modelName: "",
        modelYear: "",
        attributes: [],
        note: ""
      })
    },
    removeSearchMachine(index) {
      this.searchingMachines.splice(index, 1);
    },
    removeOwnMachine(index) {
      this.ownMachines.splice(index, 1);
    },
    updateSearchMachines() {
      const payload = {
        searchingMachines: this.searchingMachines
      }

      CollectionService.updateCollectionItem('company/searching-machines', this.company._id, payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Aradığı Makinalar Güncellendi")
          this.$router.push(`/admin/companies`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    updateOwnMachines() {
      const payload = {
        ownMachines: this.ownMachines
      }

      CollectionService.updateCollectionItem('company/own-machines', this.company._id, payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Sahip Olduğu Makinalar Güncellendi")
          this.$router.push(`/admin/companies`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    addAttributeSearchingMachines(machineIndex) {
      if (!this.searchingMachines[machineIndex].attributes) {
        this.$set(this.searchingMachines[machineIndex], 'attributes', []);
      }
      this.searchingMachines[machineIndex].attributes.push({
        key: '',
        value: ''
      });
    },
    removeAttributeSearchingMacnines(machineIndex, attributeIndex) {
      this.searchingMachines[machineIndex].attributes.splice(attributeIndex, 1);
    },
    addAttributeOwnMachines(machineIndex) {
      if (!this.ownMachines[machineIndex].attributes) {
        this.$set(this.ownMachines[machineIndex], 'attributes', []);
      }
      this.ownMachines[machineIndex].attributes.push({
        key: '',
        value: ''
      });
    },
    removeAttributeOwnMachines(machineIndex, attributeIndex) {
      this.ownMachines[machineIndex].attributes.splice(attributeIndex, 1);
    }
  }
}
</script>
<style>
.nav-tabs .nav-link {
  cursor: pointer;
}

.attributes-container {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  background-color: #f8f9fa;
}

.attributes-container .form-control-sm {
  width: 45%; /* Adjust as needed */
}

.attributes-container .btn-sm {
  padding: 0.25rem 0.5rem;
}
</style>